module.exports = __webpack_public_path__ + "img/king-of-pops-1.9d555e18.png";